














































import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";

// Components
import UserWell from "@/components/app/admin/users/userWellLink.vue";
import ClientWellLink from "@/components/app/admin/clients/clientWellLink.vue";
import CProdGridItem from "@/components/app/global/contractProducts/cProdGridItem.vue";

// Providers
import UserProvider from "@/components/app/admin/users/userProvider.vue";
import ClientProvider from "@/components/app/global/client/clientProvider.vue";
import CProdProvider from "@/components/app/global/contractProducts/cProdProvider.vue";

// Data/Enums
import { ProductCategoryTypes } from "@/data/enums/products";
import { UpmindObjectTypes } from "@/data/enums/objects";
import { DataModules } from "@/store/modules/data";

// Types
import { IHookLog } from "@/models/hooks";
import { IClientProviderData } from "@/models/providers/client";

@Component
export default class TimelineLogModal extends Vue {
  @Prop({ required: true })
  public data!: IHookLog;

  // Getters
  public get eventName() {
    return (
      this.$t(`_hook.${this.data.hook?.code}_name`) || this.data.hook?.name
    );
  }

  public get actorComponent() {
    return this.$store.getters[`data/${DataModules.LOGS}/getActorComponent`](
      this.data.access_role,
      this.data.access_user_id,
      this.data.actor
    );
  }

  public get hookLog() {
    return this.$_.omit(this.data, ["_order"]);
  }

  public get objectUI() {
    if (this.data.object_type === UpmindObjectTypes.CONTRACTS_PRODUCT) {
      return {
        component: {
          name: "TimelineLogCProd",
          render: (h: CreateElement) => {
            const props = {
              contractId: this.data.object?.contract_id
            };
            if (
              ProductCategoryTypes.PRODUCT_OPTION ===
              this.data.object?.product?.category?.category_type
            )
              props["productOptionId"] = this.data.object_id;
            else if (
              ProductCategoryTypes.PRODUCT_ATTRIBUTE ===
              this.data.object?.product?.category?.category_type
            )
              props["productAttributeId"] = this.data.object_id;
            else props["productId"] = this.data.object_id;

            return h(CProdProvider, {
              props: {
                ...props,
                handleLoading: false,
                onNotFound: () => {
                  // Do nothing, no redirecting
                }
              },
              scopedSlots: {
                default: ({ $cProdData }) => {
                  return h(CProdGridItem, {
                    props: {
                      action: this.$t("_action.go_to_product"),
                      cProd: $cProdData.contractProduct,
                      clientId: $cProdData?.contract?.client_id,
                      isLoading: $cProdData.isLoading,
                      showSkeletons: !$cProdData.contractProduct
                    }
                  });
                }
              }
            });
          }
        }
      };
    } else if (this.data.object_type === UpmindObjectTypes.USER) {
      if (!this.data.object?.id || !!this.data.object?.api_user) return null;
      return {
        component: {
          name: "TimelineLogUser",
          render: (h: CreateElement) =>
            h(UserProvider, { props: { userId: this.data.object?.id } }, [
              h(UserWell)
            ])
        }
      };
    } else if (this.data.object_type === UpmindObjectTypes.CLIENT) {
      return {
        component: {
          name: "TimelineLogClient",
          render: (h: CreateElement) =>
            h(ClientProvider, {
              props: {
                clientId: this.data.object_id,
                onNotFound: () => {
                  // Do nothing, no redirecting
                }
              },
              scopedSlots: {
                default: (props: { $clientData: IClientProviderData }) => {
                  const { $clientData } = props;
                  return h(ClientWellLink, {
                    props: {
                      client: $clientData.client,
                      clientId: this.data.object_id
                    },
                    nativeOn: {
                      click: () => this.$emit("close")
                    }
                  });
                }
              }
            })
        }
      };
    }

    return null;
  }
}
